var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_444_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 7.33334H16.5L22 12.8333H34.8333C35.8058 12.8333 36.7384 13.2197 37.4261 13.9073C38.1137 14.5949 38.5 15.5275 38.5 16.5V31.1667C38.5 32.1391 38.1137 33.0718 37.4261 33.7594C36.7384 34.447 35.8058 34.8333 34.8333 34.8333H9.16667C8.19421 34.8333 7.26158 34.447 6.57394 33.7594C5.88631 33.0718 5.5 32.1391 5.5 31.1667V11C5.5 10.0275 5.88631 9.09492 6.57394 8.40729C7.26158 7.71965 8.19421 7.33334 9.16667 7.33334Z",
    stroke: "#141C25",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_444_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolder);
export default __webpack_public_path__ + "static/media/Icon_Folder.d2866d7f1b760fb96ac94aa39b36c0f1.svg";
export { ForwardRef as ReactComponent };